import { NETWORK_CHAIN_ID } from '../../connectors/index'

export const DEFAULT_TOKEN_LIST = {
  name: 'Uniswap Default List',
  timestamp: '2021-01-21T23:57:10.982Z',
  version: {
    major: 2,
    minor: 0,
    patch: 0
  },
  tags: {},
  logoURI: 'ipfs://QmNa8mQkrNKp1WEEeGjFezDmDeodkWRevGFN8JCV7b4Xir',
  keywords: ['uniswap', 'default'],
  tokens:
    process.env.REACT_APP_ENV === 'production'
      ? [
          {
            name: 'Top',
            address: '0x152e00d27b612Bc6901a411bbad67b26c731FB81',
            symbol: 'Top',
            decimals: 6,
            chainId: NETWORK_CHAIN_ID,
            logoURI: 'https://www.topnetwork.org/static/images/top.png'
          },
          {
            name: 'TopUSDT',
            address: '0x0d43D507efDF09e14aE665B36352c4056188D4d8',
            symbol: 'TopUSDT',
            decimals: 18,
            chainId: NETWORK_CHAIN_ID,
            logoURI: 'https://dex.topnetwork.org/images/usdc.png'
          }
          // {
          //   name: 'Usdc',
          //   address: '0x27566Fcbc145F53EB38FB1a92f3e0fDAc04f8BcC',
          //   symbol: 'Usdc',
          //   decimals: 18,
          //   chainId: NETWORK_CHAIN_ID,
          //   logoURI: 'https://dex.topnetwork.org/images/usdc.png'
          // },
          // {
          //   name: 'Usdt',
          //   address: '0x2fd6F64a1Bf7C11203FBBce1E3286a05Cb80C380',
          //   symbol: 'Usdt',
          //   decimals: 18,
          //   chainId: NETWORK_CHAIN_ID,
          //   logoURI: 'https://dex.topnetwork.org/images/usdt.png'
          // }
        ]
      : [
          {
            name: 'Top',
            address: '0x7e5eF930DA3b4F777dA4fAfb958047A5CaAe5D8b',
            symbol: 'Top',
            decimals: 6,
            chainId: NETWORK_CHAIN_ID,
            logoURI: 'https://www.topnetwork.org/static/images/top.png'
          }
        ]
}
